// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =========================================
   1. FŐ ELRENDEZÉS ÉS KONTÉNEREK (LAYOUT)
   ========================================= */

/* Az oldalak legkülső burka (A háttér és a margó kezelése) */
.szakjelentes-create-wrapper .uj-szak-page {
    padding: 40px;
    display: flex;
    justify-content: center;
    transition: margin-right 0.5s cubic-bezier(0.25, 0.1, 0.25, 1);
}

/* A fő fehér űrlap-doboz (15 létrehozó oldal + Lezárás oldal) */
.szakjelentes-create-wrapper .uj-szak-container,
.szakjelentes-create-wrapper .szakjelentes-details .details-container {
    flex: 1 1;
    width: calc(100% - 80px);
    margin: 30px auto 20px auto;
    background: #f9f9f9;
    padding: 20px;
    border-radius: 10px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    max-width: none;
    transition: margin-right 0.5s cubic-bezier(0.25, 0.1, 0.25, 1);
    
    /* Hosszú linkek automatikus sortörése a kilógás ellen: */
    overflow-wrap: break-word; 
    word-break: break-word;
}

/* Általános kártya dizájn kisebb blokkokhoz */
.szakjelentes-create-wrapper .card {
    border: 1px solid #ddd;
    border-radius: 4px;
    padding: 16px;
    margin-bottom: 16px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}


/* =========================================
   2. TIPOGRÁFIA ÉS STATIKUS SZÖVEGEK
   ========================================= */

.szakjelentes-create-wrapper h1 {
    text-align: left;
    margin-left: 0px;
    font-size: 2rem;
    font-weight: bold;
}

.szakjelentes-create-wrapper h2 {
    font-size: 1.5em;
    margin-bottom: 15px;
}

.szakjelentes-create-wrapper h3 {
    font-size: 1.2em;
    margin-bottom: 10px;
}

.szakjelentes-create-wrapper label {
    display: block;
    font-weight: bold;
    margin-bottom: 5px;
}

/* Csak olvasható (read-only) formázott szövegdobozok (pl. Képzés célja) */
.szakjelentes-create-wrapper .read-only-content {
    padding: 12px;
    background-color: #f5f5f5;
    border: 1px solid #ddd;
    border-radius: 4px;
    min-height: 60px;
    line-height: 1.6;
    color: #333;
}

.szakjelentes-create-wrapper .read-only-content p { margin: 8px 0; }
.szakjelentes-create-wrapper .read-only-content ul,
.szakjelentes-create-wrapper .read-only-content ol { margin: 8px 0; padding-left: 24px; }
.szakjelentes-create-wrapper .read-only-content ul { list-style-type: disc; }
.szakjelentes-create-wrapper .read-only-content ol { list-style-type: decimal; }
.szakjelentes-create-wrapper .read-only-content li { margin: 4px 0; }
.szakjelentes-create-wrapper .read-only-content ul ul { list-style-type: circle; }
.szakjelentes-create-wrapper .read-only-content ul ul ul { list-style-type: square; }


/* =========================================
   3. ŰRLAP ELEMEK (FORMS)
   ========================================= */

.szakjelentes-create-wrapper .form-group {
    margin-bottom: 20px;
}

/* Általános több soros szövegbeviteli mezők */
.szakjelentes-create-wrapper textarea {
    width: 100%;
    height: auto;
    padding: 10px;
    border: 1px solid #ddd;
    border-radius: 4px;
    resize: vertical;
    min-height: 100px;
    font-size: 1em;
}


/* =========================================
   4. GOMBOK ÉS NAVIGÁCIÓ (BUTTONS)
   ========================================= */

/* --- Gomb Konténerek --- */
.szakjelentes-create-wrapper .button-container {
    display: flex;
    justify-content: space-between;
    margin-top: 20px;
}

.szakjelentes-create-wrapper .szak-button-container,
.szakjelentes-create-wrapper .test-status-button-container {
    display: flex;
    justify-content: center;
    margin-top: 20px;
}

/* --- Alapvető Elsődleges Gombok (Kék) --- */
.szakjelentes-create-wrapper .nav-button,
.szakjelentes-create-wrapper .szak-button,
.szakjelentes-create-wrapper .finalize-button,
.szakjelentes-create-wrapper button[type="submit"] {
    padding: 10px 20px;
    background-color: #44ACC9;
    color: white;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    transition: background-color 0.3s ease;
    margin: 20px;
    font-size: 16px;
}

/* Hover állapotok aktív gomboknál (Mozgás letiltásával) */
.szakjelentes-create-wrapper .nav-button:hover:not(:disabled),
.szakjelentes-create-wrapper .szak-button:hover:not(:disabled),
.szakjelentes-create-wrapper .finalize-button:hover:not(:disabled),
.szakjelentes-create-wrapper button[type="submit"]:hover:not(:disabled) {
    background-color: #3a94b1 !important;
    transform: none !important;
    box-shadow: none !important;
}

/* --- KIKAPCSOLT (Disabled) Állapotok --- */
/* Véd a hover színváltás és a globális CSS ugrások ellen is */
.szakjelentes-create-wrapper .szak-button:disabled,
.szakjelentes-create-wrapper .finalize-button:disabled,
.szakjelentes-create-wrapper .finalize-button:disabled:hover,
.szakjelentes-create-wrapper .nav-button:disabled,
.szakjelentes-create-wrapper button[type="submit"]:disabled,
.szakjelentes-create-wrapper button[type="submit"]:disabled:hover {
    background-color: #d4d4d4 !important;
    color: #5e5e5e !important;
    cursor: not-allowed !important;
    box-shadow: 0 1px 3px rgba(0,0,0,0.1) !important;
    border: 1px solid #c0c0c0 !important;
    transform: none !important;
    margin-top: 10px !important;
}

/* --- Speciális és Fallback Gombok --- */
/* Piros Teszt Státusz gomb */
.szakjelentes-create-wrapper .test-status-button {
    background-color: #ff4444;
    color: white;
    padding: 10px 15px;
    border: none;
    border-radius: 5px;
    font-size: 14px;
    cursor: pointer;
    font-weight: bold;
    transition: background-color 0.3s;
}

.szakjelentes-create-wrapper .test-status-button:hover {
    background-color: #cc0000;
}

/* Szövegszerkesztő (Rich Text Editor) apró gombjainak védelme */
.szakjelentes-create-wrapper .button-container button[type="button"]:not(.finalize-button):not(.nav-button):not(.szak-button):not(.delete-image-button) {
    background-color: #f0f0f0;
    color: #333;
    padding: 10px 20px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
}

/* =========================================
   5. OLDALSÓ MENÜ (SIDE-TILE) INTERAKCIÓ
   ========================================= */

/* Amikor a SideTile.js kinyílik, a JS rárakja a .side-tile-open osztályt.
   Ekkor a konténer kap egy jobb margót, hogy ne csússzon a menü alá. */
.szakjelentes-create-wrapper .uj-szak-container.side-tile-open,
.szakjelentes-create-wrapper .details-container.side-tile-open {
    margin-right: 350px !important; 
}
`, "",{"version":3,"sources":["webpack://./src/components/szakjelentesCreate/SzakjelentesCreate.css"],"names":[],"mappings":"AAAA;;8CAE8C;;AAE9C,6DAA6D;AAC7D;IACI,aAAa;IACb,aAAa;IACb,uBAAuB;IACvB,8DAA8D;AAClE;;AAEA,gEAAgE;AAChE;;IAEI,SAAO;IACP,wBAAwB;IACxB,2BAA2B;IAC3B,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uCAAuC;IACvC,eAAe;IACf,8DAA8D;;IAE9D,yDAAyD;IACzD,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA,8CAA8C;AAC9C;IACI,sBAAsB;IACtB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,wCAAwC;AAC5C;;;AAGA;;8CAE8C;;AAE9C;IACI,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA,0EAA0E;AAC1E;IACI,aAAa;IACb,yBAAyB;IACzB,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,WAAW;AACf;;AAEA,oDAAoD,aAAa,EAAE;AACnE;qDACqD,aAAa,EAAE,kBAAkB,EAAE;AACxF,qDAAqD,qBAAqB,EAAE;AAC5E,qDAAqD,wBAAwB,EAAE;AAC/E,qDAAqD,aAAa,EAAE;AACpE,wDAAwD,uBAAuB,EAAE;AACjF,2DAA2D,uBAAuB,EAAE;;;AAGpF;;8CAE8C;;AAE9C;IACI,mBAAmB;AACvB;;AAEA,8CAA8C;AAC9C;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;AAClB;;;AAGA;;8CAE8C;;AAE9C,4BAA4B;AAC5B;IACI,aAAa;IACb,8BAA8B;IAC9B,gBAAgB;AACpB;;AAEA;;IAEI,aAAa;IACb,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA,6CAA6C;AAC7C;;;;IAII,kBAAkB;IAClB,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,sCAAsC;IACtC,YAAY;IACZ,eAAe;AACnB;;AAEA,0DAA0D;AAC1D;;;;IAII,oCAAoC;IACpC,0BAA0B;IAC1B,2BAA2B;AAC/B;;AAEA,4CAA4C;AAC5C,8DAA8D;AAC9D;;;;;;IAMI,oCAAoC;IACpC,yBAAyB;IACzB,8BAA8B;IAC9B,gDAAgD;IAChD,oCAAoC;IACpC,0BAA0B;IAC1B,2BAA2B;AAC/B;;AAEA,yCAAyC;AACzC,6BAA6B;AAC7B;IACI,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,iBAAiB;IACjB,iCAAiC;AACrC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,gEAAgE;AAChE;IACI,yBAAyB;IACzB,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,eAAe;AACnB;;AAEA;;8CAE8C;;AAE9C;uEACuE;AACvE;;IAEI,8BAA8B;AAClC","sourcesContent":["/* =========================================\n   1. FŐ ELRENDEZÉS ÉS KONTÉNEREK (LAYOUT)\n   ========================================= */\n\n/* Az oldalak legkülső burka (A háttér és a margó kezelése) */\n.szakjelentes-create-wrapper .uj-szak-page {\n    padding: 40px;\n    display: flex;\n    justify-content: center;\n    transition: margin-right 0.5s cubic-bezier(0.25, 0.1, 0.25, 1);\n}\n\n/* A fő fehér űrlap-doboz (15 létrehozó oldal + Lezárás oldal) */\n.szakjelentes-create-wrapper .uj-szak-container,\n.szakjelentes-create-wrapper .szakjelentes-details .details-container {\n    flex: 1;\n    width: calc(100% - 80px);\n    margin: 30px auto 20px auto;\n    background: #f9f9f9;\n    padding: 20px;\n    border-radius: 10px;\n    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\n    max-width: none;\n    transition: margin-right 0.5s cubic-bezier(0.25, 0.1, 0.25, 1);\n    \n    /* Hosszú linkek automatikus sortörése a kilógás ellen: */\n    overflow-wrap: break-word; \n    word-break: break-word;\n}\n\n/* Általános kártya dizájn kisebb blokkokhoz */\n.szakjelentes-create-wrapper .card {\n    border: 1px solid #ddd;\n    border-radius: 4px;\n    padding: 16px;\n    margin-bottom: 16px;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n\n/* =========================================\n   2. TIPOGRÁFIA ÉS STATIKUS SZÖVEGEK\n   ========================================= */\n\n.szakjelentes-create-wrapper h1 {\n    text-align: left;\n    margin-left: 0px;\n    font-size: 2rem;\n    font-weight: bold;\n}\n\n.szakjelentes-create-wrapper h2 {\n    font-size: 1.5em;\n    margin-bottom: 15px;\n}\n\n.szakjelentes-create-wrapper h3 {\n    font-size: 1.2em;\n    margin-bottom: 10px;\n}\n\n.szakjelentes-create-wrapper label {\n    display: block;\n    font-weight: bold;\n    margin-bottom: 5px;\n}\n\n/* Csak olvasható (read-only) formázott szövegdobozok (pl. Képzés célja) */\n.szakjelentes-create-wrapper .read-only-content {\n    padding: 12px;\n    background-color: #f5f5f5;\n    border: 1px solid #ddd;\n    border-radius: 4px;\n    min-height: 60px;\n    line-height: 1.6;\n    color: #333;\n}\n\n.szakjelentes-create-wrapper .read-only-content p { margin: 8px 0; }\n.szakjelentes-create-wrapper .read-only-content ul,\n.szakjelentes-create-wrapper .read-only-content ol { margin: 8px 0; padding-left: 24px; }\n.szakjelentes-create-wrapper .read-only-content ul { list-style-type: disc; }\n.szakjelentes-create-wrapper .read-only-content ol { list-style-type: decimal; }\n.szakjelentes-create-wrapper .read-only-content li { margin: 4px 0; }\n.szakjelentes-create-wrapper .read-only-content ul ul { list-style-type: circle; }\n.szakjelentes-create-wrapper .read-only-content ul ul ul { list-style-type: square; }\n\n\n/* =========================================\n   3. ŰRLAP ELEMEK (FORMS)\n   ========================================= */\n\n.szakjelentes-create-wrapper .form-group {\n    margin-bottom: 20px;\n}\n\n/* Általános több soros szövegbeviteli mezők */\n.szakjelentes-create-wrapper textarea {\n    width: 100%;\n    height: auto;\n    padding: 10px;\n    border: 1px solid #ddd;\n    border-radius: 4px;\n    resize: vertical;\n    min-height: 100px;\n    font-size: 1em;\n}\n\n\n/* =========================================\n   4. GOMBOK ÉS NAVIGÁCIÓ (BUTTONS)\n   ========================================= */\n\n/* --- Gomb Konténerek --- */\n.szakjelentes-create-wrapper .button-container {\n    display: flex;\n    justify-content: space-between;\n    margin-top: 20px;\n}\n\n.szakjelentes-create-wrapper .szak-button-container,\n.szakjelentes-create-wrapper .test-status-button-container {\n    display: flex;\n    justify-content: center;\n    margin-top: 20px;\n}\n\n/* --- Alapvető Elsődleges Gombok (Kék) --- */\n.szakjelentes-create-wrapper .nav-button,\n.szakjelentes-create-wrapper .szak-button,\n.szakjelentes-create-wrapper .finalize-button,\n.szakjelentes-create-wrapper button[type=\"submit\"] {\n    padding: 10px 20px;\n    background-color: #44ACC9;\n    color: white;\n    border: none;\n    border-radius: 5px;\n    cursor: pointer;\n    transition: background-color 0.3s ease;\n    margin: 20px;\n    font-size: 16px;\n}\n\n/* Hover állapotok aktív gomboknál (Mozgás letiltásával) */\n.szakjelentes-create-wrapper .nav-button:hover:not(:disabled),\n.szakjelentes-create-wrapper .szak-button:hover:not(:disabled),\n.szakjelentes-create-wrapper .finalize-button:hover:not(:disabled),\n.szakjelentes-create-wrapper button[type=\"submit\"]:hover:not(:disabled) {\n    background-color: #3a94b1 !important;\n    transform: none !important;\n    box-shadow: none !important;\n}\n\n/* --- KIKAPCSOLT (Disabled) Állapotok --- */\n/* Véd a hover színváltás és a globális CSS ugrások ellen is */\n.szakjelentes-create-wrapper .szak-button:disabled,\n.szakjelentes-create-wrapper .finalize-button:disabled,\n.szakjelentes-create-wrapper .finalize-button:disabled:hover,\n.szakjelentes-create-wrapper .nav-button:disabled,\n.szakjelentes-create-wrapper button[type=\"submit\"]:disabled,\n.szakjelentes-create-wrapper button[type=\"submit\"]:disabled:hover {\n    background-color: #d4d4d4 !important;\n    color: #5e5e5e !important;\n    cursor: not-allowed !important;\n    box-shadow: 0 1px 3px rgba(0,0,0,0.1) !important;\n    border: 1px solid #c0c0c0 !important;\n    transform: none !important;\n    margin-top: 10px !important;\n}\n\n/* --- Speciális és Fallback Gombok --- */\n/* Piros Teszt Státusz gomb */\n.szakjelentes-create-wrapper .test-status-button {\n    background-color: #ff4444;\n    color: white;\n    padding: 10px 15px;\n    border: none;\n    border-radius: 5px;\n    font-size: 14px;\n    cursor: pointer;\n    font-weight: bold;\n    transition: background-color 0.3s;\n}\n\n.szakjelentes-create-wrapper .test-status-button:hover {\n    background-color: #cc0000;\n}\n\n/* Szövegszerkesztő (Rich Text Editor) apró gombjainak védelme */\n.szakjelentes-create-wrapper .button-container button[type=\"button\"]:not(.finalize-button):not(.nav-button):not(.szak-button):not(.delete-image-button) {\n    background-color: #f0f0f0;\n    color: #333;\n    padding: 10px 20px;\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n}\n\n/* =========================================\n   5. OLDALSÓ MENÜ (SIDE-TILE) INTERAKCIÓ\n   ========================================= */\n\n/* Amikor a SideTile.js kinyílik, a JS rárakja a .side-tile-open osztályt.\n   Ekkor a konténer kap egy jobb margót, hogy ne csússzon a menü alá. */\n.szakjelentes-create-wrapper .uj-szak-container.side-tile-open,\n.szakjelentes-create-wrapper .details-container.side-tile-open {\n    margin-right: 350px !important; \n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
